import { setValueValue } from '@databases/collab/y-database';
import { DatabaseChangeType } from '@databases/types/redux';

import { YJSChangeHandler } from '../../types';

export const cloneEntries: YJSChangeHandler<DatabaseChangeType.CLONE_ENTRIES> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    // Sort entry IDs by their occurrence in the database and filter out non-existing ones
    const entryIds = db.entries.filter((entryId) =>
      Object.prototype.hasOwnProperty.call(change.entryIds, entryId)
    );

    const index = db.entries.indexOf(entryIds[entryIds.length - 1]) + 1;

    for (let i = 0; i < entryIds.length; i++) {
      const entryId = entryIds[i];
      const newEntry = db.addEntryAt(change.entryIds[entryId], index + i);
      const entryJSON = db.entriesById[entryId].toJSON();

      for (const [fieldId, valueJSON] of Object.entries(entryJSON.values)) {
        const newValue = newEntry.setValue(fieldId, valueJSON.type);

        setValueValue(newValue, valueJSON);
      }
    }
  });
};
